/* eslint-disable react/jsx-boolean-value */

const BlankBox = () => {
  return (
    <div
      style={{
        padding: '12px',
        borderRadius: '16px',
        backgroundColor: '#ffffff',
        display: 'flex',
        flexDirection: 'column',
        position: 'relative',
      }}
    >
      Blank
    </div>
  );
};
export default BlankBox;
